<div
	class="flex gap-2 items-start w-full rounded-lg border border-grey-lighter p-4 cursor-pointer h-28 bg-white"
	[ngClass]="{ 'bg-grey-lightest': checklist?.draft }"
	(click)="openChecklist()"
>
	<app-matter-type-icon [fileType]="checklist?.fileType"></app-matter-type-icon>
	<div class="flex flex-col justify-start flex-1 gap-1 w-[70%]">
		<p class="font-bold truncate">{{ checklist?.title }}</p>
		<p *ngIf="!checklist.draft" class="text-grey text-sm truncate">
			{{ checklist?.locked ? 'Closer default' : primaryAddress?.officeName }}
			<app-icon *ngIf="checklist?.locked" [icon]="ICON.LOCK"></app-icon>
		</p>
		<p *ngIf="checklist.draft" class="text-grey text-sm italic">Draft</p>
		<app-pill
			*ngIf="checklist?.default"
			class="w-fit mt-1"
			mode="secondary"
			size="small"
			>Default</app-pill
		>
	</div>
	<atomic-kebab-options
		class="-mt-3"
		(click)="onKebabClick($event)"
		(onSelect)="onKebabOptionSelected($event)"
		[itemGroups]="[{ items: kebabOptions }]"
	></atomic-kebab-options>
</div>
